var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#D63384"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5639 60.375C83.2457 57.3977 81.9048 55.0795 79.5412 53.4205C77.2003 51.7614 74.1548 50.9318 70.4048 50.9318C67.7685 50.9318 65.5071 51.3295 63.6207 52.125C61.7344 52.9205 60.2912 54 59.2912 55.3636C58.2912 56.7273 57.7798 58.2841 57.7571 60.0341C57.7571 61.4886 58.0866 62.75 58.7457 63.8182C59.4276 64.8864 60.348 65.7955 61.5071 66.5455C62.6662 67.2727 63.9503 67.8864 65.3594 68.3864C66.7685 68.8864 68.1889 69.3068 69.6207 69.6477L76.1662 71.2841C78.8026 71.8977 81.3366 72.7273 83.7685 73.7727C86.223 74.8182 88.4162 76.1364 90.348 77.7273C92.3026 79.3182 93.848 81.2386 94.9844 83.4886C96.1207 85.7386 96.6889 88.375 96.6889 91.3977C96.6889 95.4886 95.6435 99.0909 93.5526 102.205C91.4617 105.295 88.4389 107.716 84.4844 109.466C80.5526 111.193 75.7912 112.057 70.2003 112.057C64.7685 112.057 60.0526 111.216 56.0526 109.534C52.0753 107.852 48.9616 105.398 46.7116 102.17C44.4844 98.9432 43.2798 95.0114 43.098 90.375H55.5412C55.723 92.8068 56.473 94.8295 57.7912 96.4432C59.1094 98.0568 60.8253 99.2614 62.9389 100.057C65.0753 100.852 67.4616 101.25 70.098 101.25C72.848 101.25 75.2571 100.841 77.3253 100.023C79.4162 99.1818 81.0526 98.0227 82.2344 96.5455C83.4162 95.0455 84.0185 93.2955 84.0412 91.2955C84.0185 89.4773 83.4844 87.9773 82.4389 86.7955C81.3935 85.5909 79.9276 84.5909 78.0412 83.7955C76.1776 82.9773 73.9957 82.25 71.4957 81.6136L63.5526 79.5682C57.8026 78.0909 53.2571 75.8523 49.9162 72.8523C46.598 69.8295 44.9389 65.8182 44.9389 60.8182C44.9389 56.7045 46.0526 53.1023 48.2798 50.0114C50.5298 46.9205 53.5866 44.5227 57.4503 42.8182C61.3139 41.0909 65.6889 40.2273 70.5753 40.2273C75.5298 40.2273 79.8707 41.0909 83.598 42.8182C87.348 44.5227 90.2912 46.8977 92.4276 49.9432C94.5639 52.9659 95.6662 56.4432 95.7344 60.375H83.5639ZM117.305 41.1818L135.476 96.1364H136.192L154.328 41.1818H168.237L143.624 111H128.01L103.43 41.1818H117.305ZM220.456 63.4773C219.888 61.6364 219.104 59.9886 218.104 58.5341C217.126 57.0568 215.945 55.7955 214.558 54.75C213.195 53.7045 211.626 52.9205 209.854 52.3977C208.081 51.8523 206.149 51.5795 204.058 51.5795C200.308 51.5795 196.967 52.5227 194.036 54.4091C191.104 56.2955 188.797 59.0682 187.115 62.7273C185.456 66.3636 184.626 70.7955 184.626 76.0227C184.626 81.2955 185.456 85.7614 187.115 89.4205C188.774 93.0795 191.081 95.8636 194.036 97.7727C196.99 99.6591 200.422 100.602 204.331 100.602C207.876 100.602 210.945 99.9205 213.536 98.5568C216.149 97.1932 218.161 95.2614 219.57 92.7614C220.979 90.2386 221.683 87.2841 221.683 83.8977L224.547 84.3409H205.592V74.4545H233.922V82.8409C233.922 88.8182 232.649 93.9886 230.104 98.3523C227.558 102.716 224.058 106.08 219.604 108.443C215.149 110.784 210.036 111.955 204.263 111.955C197.831 111.955 192.183 110.511 187.32 107.625C182.479 104.716 178.695 100.591 175.967 95.25C173.263 89.8864 171.911 83.5227 171.911 76.1591C171.911 70.5227 172.706 65.4886 174.297 61.0568C175.911 56.625 178.161 52.8636 181.047 49.7727C183.933 46.6591 187.32 44.2955 191.206 42.6818C195.092 41.0455 199.32 40.2273 203.888 40.2273C207.751 40.2273 211.354 40.7955 214.695 41.9318C218.036 43.0455 221.001 44.6364 223.592 46.7045C226.206 48.7727 228.354 51.2273 230.036 54.0682C231.717 56.9091 232.82 60.0455 233.342 63.4773H220.456Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273.458 423.165V398.426L192.729 358.061H143.25V300.77H188.823L221.375 264.311V214.832H278.667V272.124H235.438L200.542 311.186V344.78L273.458 380.978V365.874H330.75V423.165H273.458ZM237 256.499H263.042V230.457H237V256.499ZM158.875 342.436H184.917V316.395H158.875V342.436ZM289.083 407.54H315.125V381.499H289.083V407.54Z",
    fill: "#D63384"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_988",
    x: 31.0977,
    y: 40.2266,
    width: 206.824,
    height: 87.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_988",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.be667f8d2178b2aa5dfbb57dd54cd5ad.svg";
export { ForwardRef as ReactComponent };